import { FOOTER } from "../data/mock";
import { Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  const isInternalLink = (href) => href.startsWith("/") && !href.startsWith("/#");

  return (
    <footer className="bg-[#2C2A2B] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/">
              <img
                src="/assets/logo-full.svg"
                alt="Asterisk Computer"
                className="h-[120px] w-auto mb-5"
              />
            </Link>
            <p className="text-sm text-[#A9B294] leading-relaxed max-w-xs mb-6">
              {FOOTER.tagline}
            </p>
            <div className="space-y-3">
              <a
                href={`mailto:${FOOTER.contact.email}`}
                className="flex items-center gap-3 text-sm text-[#D5CFC9] hover:text-[#E5BD77] transition-colors"
              >
                <Mail className="w-4 h-4 text-[#E5BD77]" />
                {FOOTER.contact.email}
              </a>
              <a
                href={`tel:${FOOTER.contact.phone}`}
                className="flex items-center gap-3 text-sm text-[#D5CFC9] hover:text-[#E5BD77] transition-colors"
              >
                <Phone className="w-4 h-4 text-[#E5BD77]" />
                {FOOTER.contact.phone}
              </a>
              <div className="flex items-start gap-3 text-sm text-[#D5CFC9]">
                <MapPin className="w-4 h-4 text-[#E5BD77] mt-0.5 shrink-0" />
                {FOOTER.contact.address}
              </div>
            </div>
          </div>

          {/* Link Columns */}
          {FOOTER.links.map((col, i) => (
            <div key={i}>
              <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-5">
                {col.heading}
              </h4>
              <ul className="space-y-3">
                {col.items.map((link, j) => (
                  <li key={j}>
                    {isInternalLink(link.href) ? (
                      <Link
                        to={link.href}
                        onClick={() => window.scrollTo(0, 0)}
                        className="text-sm text-[#8A8385] hover:text-[#E5BD77] transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-sm text-[#8A8385] hover:text-[#E5BD77] transition-colors duration-200"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/[0.06]">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#6B6567]">{FOOTER.copyright}</p>
          <p className="text-xs text-[#6B6567]">
            Powered by Asterisk Labs
          </p>
        </div>
      </div>
    </footer>
  );
};
